module.exports = __webpack_public_path__ + "static/media/icon_maker_red_1.a2ff6158.svg";